import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { BehaviorSubject, debounceTime, distinctUntilChanged } from "rxjs";
import constructTree from "../../helpers/constructTree";
import Filter from "../../../../models/Filter";
import FilterNode from "./FilterNode";
import partition from "../../helpers/partition";
import FilterComponent from "./FilterComponent";

function FilterContainer({ filters, applyFilters, applyFilterHighlight }) {
  const highlighter$ = useRef(new BehaviorSubject());
  const getKey = (x) => x.nestId;
  const getCategory = (x) => x.category;
  const filterDict = filters.reduce((a, i) => a.set(i.id, i), new Map());
  const tree = constructTree(filters, getKey, getCategory);
  const [nodes, leafs] = partition(tree, (x) => x.isLeaf);

  const handleChange = ({ ids, value }) => {
    ids.map((x) => filterDict.get(x)).forEach((x) => (x.value = value));
    applyFilters(filters);
  };

  const handleHighlight = (params) => {
    highlighter$.current.next(params);
  };

  useEffect(() => {
    const sub1 = highlighter$.current
      .pipe(distinctUntilChanged(), debounceTime(100))
      .subscribe((x) => applyFilterHighlight(x));

    const sub2 = highlighter$.current
      .pipe(debounceTime(1000))
      .subscribe(() => applyFilterHighlight(null));

    return () => {
      highlighter$.current.next(null);
      sub1.unsubscribe();
      sub2.unsubscribe();
    };
  }, [applyFilterHighlight]);

  return (
    <div
      className="tw-pl-3 tw-pt-1 tw-pb-2 tw-min-w-72"
      onMouseLeave={() => handleHighlight(null)}
    >
      {nodes.map((x) => (
        <FilterNode
          level={1}
          key={x.id}
          handleChange={handleChange}
          handleHighlight={handleHighlight}
          node={x}
        />
      ))}
      {leafs.map((n) => (
        <FilterComponent
          key={n.id}
          handleHighlight={handleHighlight}
          handleChange={handleChange}
          filter={n.data}
        />
      ))}
    </div>
  );
}

FilterContainer.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.instanceOf(Filter)).isRequired,
  applyFilters: PropTypes.func.isRequired,
  applyFilterHighlight: PropTypes.func.isRequired,
};

export default FilterContainer;
